import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  workOrderDetail: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%"
  },
  noResultsBlock: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  logoIcon: {
    position: "absolute",
    zIndex: 0,
    width: 170,
    height: 170,
    opacity: 0.05
  },
  noSelectedText: {
    opacity: 0.7,
    color: "#333333",
    fontSize: 13
  },
  detailHeaderWrapper: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      position: "sticky",
      top: 0
    }
  },
  detailHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 47,
    background: theme.palette.common.white,
    paddingRight: 12,
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
      minHeight: 60
    }
  },
  detailTitle: {
    display: "flex",
    alignItems: "center",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "#1a1a1a",
    lineHeight: "41px",
    fontSize: 14,
    margin: "0 0 0 16px",
    [theme.breakpoints.down("xs")]: {
      margin: 0,
      fontSize: 18
    }
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 5
  },
  dotsButton: {
    paddingRight: 12,
    minWidth: 40
  }
}));
